import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useIsMobile } from '../../hooks/useIsMobile';

const nav = [
  { to: '/superadmin',              icon: '🏢', label: 'Empresas', end: true },
  { to: '/superadmin/plans',        icon: '💳', label: 'Planos' },
  { to: '/superadmin/integrations', icon: '🔌', label: 'Integrações' },
];

export default function SuperadminLayout({ children }) {
  const { operator, logout } = useAuth();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };
  const closeDrawer = () => setDrawerOpen(false);

  const menu = (
    <>
      <div style={styles.brand}>
        <span style={styles.brandIcon}>⚡</span>
        <div>
          <div style={styles.brandName}>SUPERADMIN</div>
          <div style={styles.brandSub}>Agência Interativa</div>
        </div>
      </div>
      <nav style={styles.nav}>
        {nav.map(item => (
          <NavLink key={item.to} to={item.to} end={item.end} onClick={closeDrawer}
            style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navActive : {}) })}>
            <span style={styles.navIcon}>{item.icon}</span>{item.label}
          </NavLink>
        ))}
      </nav>
      <div style={styles.bottom}>
        <div style={styles.operator}>
          <div style={styles.operatorAvatar}>{operator?.name?.charAt(0).toUpperCase()}</div>
          <div>
            <div style={styles.operatorName}>{operator?.name}</div>
            <div style={styles.operatorRole}>Plataforma</div>
          </div>
        </div>
        <button onClick={handleLogout} style={styles.logoutBtn}>Sair</button>
      </div>
    </>
  );

  if (isMobile) {
    return (
      <div style={styles.mobileWrapper}>
        <header style={styles.topbar}>
          <button style={styles.hamburger} onClick={() => setDrawerOpen(true)} aria-label="Menu">☰</button>
          <div style={styles.topbarBrand}><span style={{ fontSize: 20 }}>⚡</span><span style={styles.topbarName}>SUPERADMIN</span></div>
          <div style={styles.topbarAvatar}>{operator?.name?.charAt(0).toUpperCase()}</div>
        </header>
        {drawerOpen && (<>
          <div style={styles.scrim} onClick={closeDrawer} />
          <aside style={{ ...styles.sidebar, ...styles.drawer }}>{menu}</aside>
        </>)}
        <main style={styles.mainMobile}>{children}</main>
      </div>
    );
  }

  return (
    <div style={styles.wrapper}>
      <aside style={styles.sidebar}>{menu}</aside>
      <main style={styles.main}>{children}</main>
    </div>
  );
}

const styles = {
  wrapper: { display: 'flex', minHeight: '100vh', background: '#0a0a0f', fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif' },
  mobileWrapper: { minHeight: '100vh', background: '#0a0a0f', fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif' },
  sidebar: { width: 230, background: '#14141f', borderRight: '1px solid #262636', display: 'flex', flexDirection: 'column', flexShrink: 0 },
  drawer: { position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 100, boxShadow: '2px 0 24px rgba(0,0,0,0.6)' },
  scrim: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 99 },
  topbar: { position: 'sticky', top: 0, zIndex: 40, height: 56, background: '#14141f', borderBottom: '1px solid #262636', display: 'flex', alignItems: 'center', gap: 12, padding: '0 14px' },
  hamburger: { background: 'transparent', border: 'none', color: '#e5e7eb', fontSize: 24, cursor: 'pointer', lineHeight: 1, padding: 4 },
  topbarBrand: { display: 'flex', alignItems: 'center', gap: 8, flex: 1 },
  topbarName: { color: '#fff', fontWeight: 800, fontSize: 15, letterSpacing: 1 },
  topbarAvatar: { width: 32, height: 32, borderRadius: '50%', background: '#1a2e05', color: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13 },
  brand: { display: 'flex', alignItems: 'center', gap: 10, padding: '24px 20px', borderBottom: '1px solid #262636' },
  brandIcon: { fontSize: 26 },
  brandName: { color: 'var(--accent)', fontWeight: 800, fontSize: 15, letterSpacing: 1 },
  brandSub: { color: '#6b7280', fontSize: 11 },
  nav: { flex: 1, padding: '16px 12px', display: 'flex', flexDirection: 'column', gap: 4 },
  navItem: { display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 8, color: '#9ca3af', textDecoration: 'none', fontSize: 14, fontWeight: 500 },
  navActive: { background: '#1a2e05', color: '#bef264' },
  navIcon: { fontSize: 18, width: 22, textAlign: 'center' },
  bottom: { padding: '16px 12px', borderTop: '1px solid #262636' },
  operator: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 },
  operatorAvatar: { width: 34, height: 34, borderRadius: '50%', background: '#1a2e05', color: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 14 },
  operatorName: { color: '#e5e7eb', fontSize: 13, fontWeight: 600 },
  operatorRole: { color: '#6b7280', fontSize: 11 },
  logoutBtn: { width: '100%', padding: '8px', background: 'transparent', border: '1px solid #374151', borderRadius: 6, color: '#9ca3af', cursor: 'pointer', fontSize: 13 },
  main: { flex: 1, overflow: 'auto', padding: 28 },
  mainMobile: { padding: 16 },
};
